export const storeTokens = (tokenStorage, { accessToken, refreshToken }) => {
    tokenStorage.accessToken.set(accessToken);
    if (refreshToken) {
        tokenStorage.refreshToken.set(refreshToken);
    }
};
